import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class JobUnavailableChatMessage extends AbstractChatMessage {
  constructor(data: LX.JobUnavailableChatMessage) {
    super(data)
    this.body = data.body
  }

  static fromServer(data: LX.JobUnavailableChatMessage) {
    return new JobUnavailableChatMessage(data)
  }

  getShortMessage() {
    return 'This Job was removed by the customer.'
  }
}
